import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { MaterialAliasData } from '../../../shared/dto/EntityRepository';
import { useAuth } from '../../../shared/hooks/useApi/useAuth';
import { useAuthTokenStore } from '../../../shared/store/authStore';
import { useAdminMaterialAlias } from '../../share/hook/useAdminMaterialAlias';
import MaterialAliasInfo from './MaterialAliasInfo';
import MaterialAliasViewer from './MaterialAliasViewer';

const MaterialAliasList: React.FC = () => {
  const { user } = useAuth();
  const authToken = useAuthTokenStore((state) => state.authToken);
  const {
    aliasList,
    activeAlias,
    pageSize,
    unassignedOnly,
    sortField,
    sortDirection,
    setActiveAlias,
    load,
  } = useAdminMaterialAlias();
  const listRef = useRef<HTMLElement>(null);

  useEffect(() => {
    listRef.current?.focus();
  }, []);

  useEffect(() => {
    if (!user || !authToken) return;
    load(1, unassignedOnly, Number(pageSize), sortDirection, sortField);
  }, [
    user,
    authToken,
    unassignedOnly,
    pageSize,
    sortField,
    sortDirection,
  ]);

  return (
    <ListContainer ref={listRef} tabIndex={0}>
      <List>
        {aliasList.map((alias: MaterialAliasData) => (
          <MaterialAliasInfo
            key={alias.id}
            data={alias}
            isSelected={alias.id === activeAlias?.id}
            handleClick={() => setActiveAlias(alias)}
          />
        ))}
      </List>
      <MaterialAliasViewer />
    </ListContainer>
  );
};

const ListContainer = styled.article`
  width: 100%;
  height: calc(80vh - 2vh);
  display: flex;
  outline: none;
`;

const List = styled.section`
  flex: 1;
  width: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 10vh;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_04};
  position: relative;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export default MaterialAliasList;
